export const InfoBarStyleOptions = [
  { label: 'Original Info Bar', value: 'original' },
  // { label: 'Phone Right (no portal or email)', value: 'phoneRight' },
  //  { label: 'Logo Centered', value: 'logoCentered' },
  { label: 'None', value: 'none' },
];

export const LocationBarStyleOptions = [
  { label: 'Original Location Bar', value: 'original' },
  { label: 'With Locations <= 3', value: 'withLocations' },
  { label: 'Facility Bar v1.0', value: 'facility' },
  { label: 'None', value: 'none' },
];



// WEBPACK FOOTER //
// ./src/ng2/app/models/client-settings-options.ts